import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const MonthlyForecastChart = ({ onClick }) => {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: '2023 Actual',
        data: [175.05, 165.42, 179.90, 174.68, 181.74, 185.43, 188.00, 192.50, 195.30, 198.80, 202.40, 205.10],
        borderColor: '#4da6ff',
        backgroundColor: 'rgba(77, 166, 255, 0.1)',
        borderWidth: 3,
        tension: 0.4,
        fill: true,
        pointRadius: 4,
        pointHoverRadius: 6
      },
      {
        label: '2024 Forecast',
        data: [190.00, 185.00, 195.00, 192.00, 200.00, 205.00, 210.00, 215.00, 220.00, 225.00, 230.00, 235.00],
        borderColor: '#ff9f40',
        backgroundColor: 'rgba(255, 159, 64, 0.1)',
        borderWidth: 3,
        borderDash: [5, 5],
        tension: 0.4,
        fill: false,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointStyle: 'circle'
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: (event, elements) => {
      if (elements.length > 0 && onClick) {
        const element = elements[0];
        const datasetIndex = element.datasetIndex;
        const index = element.index;
        const dataset = data.datasets[datasetIndex];
        const value = dataset.data[index];
        const month = data.labels[index];
        const datasetLabel = dataset.label;
        
        onClick({
          month,
          value,
          datasetLabel,
          datasetIndex,
          index,
          year: datasetLabel.includes('2023') ? 2023 : 2024,
          isForecast: datasetLabel.includes('Forecast'),
          isActual: datasetLabel.includes('Actual')
        });
      }
    },
    scales: {
      y: {
        beginAtZero: false,
        title: {
          display: true,
          text: 'Thousand Tons'
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        },
        ticks: {
          callback: function(value) {
            return value.toFixed(0) + 'K';
          }
        }
      },
      x: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      }
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          pointStyle: 'line'
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.dataset.label || '';
            const value = context.parsed.y;
            return `${label}: ${value.toFixed(2)}K Tons`;
          },
          afterLabel: function(context) {
            const datasetIndex = context.datasetIndex;
            const index = context.dataIndex;
            
            // Calculate growth percentage for forecast vs actual
            if (datasetIndex === 1 && index < data.datasets[0].data.length) {
              const forecastValue = data.datasets[1].data[index];
              const actualValue = data.datasets[0].data[index];
              const growth = ((forecastValue - actualValue) / actualValue) * 100;
              return `Growth: ${growth > 0 ? '+' : ''}${growth.toFixed(1)}%`;
            }
            return '';
          }
        }
      }
    },
    interaction: {
      intersect: false,
      mode: 'index'
    },
    elements: {
      line: {
        tension: 0.4
      }
    }
  };

  return <Line data={data} options={options} />;
};

export default MonthlyForecastChart;